import {
	Component,
	OnInit,
	Output,
	EventEmitter,
	ChangeDetectorRef,
	ChangeDetectionStrategy,
	Input,
	OnChanges,
	SimpleChanges,
} from "@angular/core";
import { DashboardService } from "../../dashboard.service";
import { Subscription } from "rxjs";
import { getTranslation } from "../../../utils/utils";

@Component({
	selector: "rs-portlet-type-new",
	templateUrl: "./portlet-type-new.component.html",
	styleUrls: ["./portlet-type-new.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortletTypeNewComponent implements OnInit, OnChanges {
	@Input("dataMartCode") dataMartCode = "";
	@Input() portlet;
	@Input() dashboard;
	@Output() portletType = new EventEmitter();
	private datamart;
	public translation;
	private userInfo;
	public portletList;
	public type;
	private subscriptions: Subscription[] = [];

	constructor(
		private DashboardService: DashboardService,
		private ref: ChangeDetectorRef
	) {
		this.portletList = [
			{
				portletName: "Table",
				portletCode: "table",
			},
			{
				portletName: "Transpose",
				portletCode: "transpose",
			},
			{
				portletName: "Pivot",
				portletCode: "pivot",
			},
			{
				portletName: "Pie",
				portletCode: "pie",
			},
			{
				portletName: "Bar",
				portletCode: "bar",
			},
			{
				portletName: "Column",
				portletCode: "column",
			},
			{
				portletName: "Line",
				portletCode: "line",
			},
			{
				portletName: "Area",
				portletCode: "area",
			},
			{
				portletName: "Radar",
				portletCode: "radar",
			},
		];

		this.portletList = this.portletList.concat([
			{
				portletName: "NewChart",
				portletCode: "newchart",
			},
			{
				portletName: "NewColumn",
				portletCode: "newcolumn",
			},
			{
				portletName: "NewLine",
				portletCode: "newline",
			},
			{
				portletName: "NewColumnLine",
				portletCode: "newcolumnline",
			},
			// SMP2-17578/17654，仅 fund/company historical IRR 可选择
			// TODO: 需要确定 fund/company historical IRR code
			{
				portletName: "HistoricalIRR",
				portletCode: "historicalIRR",
			},
		]);
		const excludeList = ["Pie", "Bar", "Column", "Line", "Area", "Radar"];
		this.portletList =
			this.portletList.filter(
				(item) => !excludeList.includes(item.portletName)
			) || [];
	}

	ngOnInit() {
		this.getInfo();
		if (this.portlet && this.portlet.figureCode) {
			const configStr = this.portlet.config;
			if (!configStr) {
				return;
			}
			const config = JSON.parse(configStr);
			this.type = config.portletType;
		}
		this.datamart = JSON.parse(this.dashboard.config).datamartViewCode;
	}
	ngAfterViewInit(): void {
		this.subscriptions.push(
			this.DashboardService.getportletEdit().subscribe((status) => {
				if (status && this.portlet) {
					const configStr = this.portlet.config;
					if (!configStr) {
						return;
					}
					const config = JSON.parse(configStr);
					this.type = config.portletType;
					// this.portletType.emit(this.type);
					this.datamart = config.datamartViewCode;
					this.ref.markForCheck();
					this.ref.detectChanges();
				}
			})
		);
		//Michael 20200526 clear options data
		this.subscriptions.push(
			this.DashboardService.getResetbtn().subscribe((status) => {
				if (status) {
					this.type = "";
					this.portletType.emit(this.type);
					this.ref.detectChanges();
				}
			})
		);
		this.subscriptions.push(
			this.DashboardService.getPushbtn().subscribe((id) => {
				if (this.dashboard && this.dashboard.id === id) {
					this.type = "";
					this.portletType.emit(this.type);
				}
			})
		);
	}
	ngOnChanges(changes: SimpleChanges): void {
		if (changes.dataMartCode) {
			if (this.disabledHistoricalIRR && this.type === "historicalIRR") {
				this.selectPortletType(null);
			}
		}
	}
	ngOnDestroy(): void {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}

	get disabledHistoricalIRR() {
		return ![
			"FundHistoricalCashflowIRR",
			"FundHistoricalGrossIRR",
		].includes(this.dataMartCode);
	}

	public setTooltip(item) {
		if (!item) return "";
		switch (item.portletName) {
			case "Table":
				return this.translation.TABLE || ".TABLE";
			case "Transpose":
				return `${this.translation.TRANSPOSE || ".TRANSPOSE"} ${
					this.translation.TABLE || ".TABLE"
				}`;
			case "Pivot":
				return `${this.translation.PIVOT || ".PIVOT"} ${
					this.translation.TABLE || ".TABLE"
				}`;
			case "NewChart":
				return `${this.translation.PIVOT || ".PIVOT"} ${
					this.translation.COMPANY_CHART || ".COMPANY_CHART"
				}`;
			case "NewColumn":
				return `${
					this.translation.CLUSTERED_COLUMN || ".CLUSTERED_COLUMN"
				} ${this.translation.COMPANY_CHART || ".COMPANY_CHART"}`;
			case "NewLine":
				return `${this.translation.LINE || ".LINE"} ${
					this.translation.COMPANY_CHART || ".COMPANY_CHART"
				}`;
			case "NewColumnLine":
				return `${this.translation.LINE || ".LINE"} ${
					this.translation.AND || ".AND"
				} ${this.translation.CLUSTERED_COLUMN || ".CLUSTERED_COLUMN"} ${
					this.translation.COMPANY_CHART || ".COMPANY_CHART"
				}`;
			case "HistoricalIRR":
				return `${this.translation.HISTORICAL} ${this.translation.IRR}`;
			default:
				return "";
		}
	}

	public selectPortletType(portletCode) {
		this.type = portletCode;
		this.portletType.emit(portletCode);
	}
	private getInfo() {
		this.translation = getTranslation()
		this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
	}
	public getFinancialType() {
		if (this.datamart) {
			return this.datamart.toLocaleLowerCase().indexOf("financial") > -1
				? true
				: false;
		}
	}
	public getFPPType(code) {
		let type_ = [
			"table",
			"pivot",
			"pie",
			"bar",
			"column",
			"line",
			"area",
			"multiSeries",
			"geo",
			"radar",
		];
		return type_.indexOf(code) > -1 ? true : false;
	}
}
